// extracted by mini-css-extract-plugin
module.exports = {"heading":"SettingsGeneral_heading__306y4","subHeading":"SettingsGeneral_subHeading__1lgSL","headingSm":"SettingsGeneral_headingSm__1Pl1B"};